export const AppConfig = {
  server: "https://ap1.appbp.xyz/",
  appVersion:"1.1.3.2",
  appVersionCode:41,
};
